import { render, staticRenderFns } from "./EditUsersComponent.vue?vue&type=template&id=65318e30&scoped=true"
import script from "./EditUsersComponent.vue?vue&type=script&lang=js"
export * from "./EditUsersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65318e30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65318e30')) {
      api.createRecord('65318e30', component.options)
    } else {
      api.reload('65318e30', component.options)
    }
    module.hot.accept("./EditUsersComponent.vue?vue&type=template&id=65318e30&scoped=true", function () {
      api.rerender('65318e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/EditUsersComponent.vue"
export default component.exports